import { Header, Icon } from "semantic-ui-react";
import store from 'store2';

// Frontend Version - Update this value when releasing new frontend versions
export const FRONTEND_VERSION = '1.0.2';

export const GREATER_OF_CATEGORIES = {
    A: {
        name: 'Category A',
        description: 'Standard daily rate calculation',
        formula: 'Daily Rate × Days Worked',
        details: 'Uses standard daily rate multiplied by number of days worked'
    },
    B: {
        name: 'Category B',
        description: 'Fixed monthly base pay',
        formula: 'Monthly Base Pay',
        details: 'Always returns the monthly base pay regardless of days worked'
    },
    C: {
        name: 'Category C',
        description: 'Capped daily rate calculation',
        formula: 'Daily Rate × Days Worked (Capped at Monthly Base Pay)',
        details: 'Daily rate multiplied by days worked, but not exceeding monthly base pay'
    }
};

export const permissionRoles = ['Admin', 'View Only', 'Regional Manager', 'Dentist', 'Hygienists', 'Oral Surgeon', 'Pediatric']
export const menusArray = [
    {
        pageId: 54, name: "clinical", icon: "user md", title: "CLINICAL", subMenus: [
            {
                pageId: 31,
                name: "constitution",
                customIcon: "constitution alternate outline",
                label: "CONSTITUTION",
                title: "CONSTITUTION",
                subMenus: [],
                role: [],
                hide: false
            },
            {
                pageId: 402,
                name: "performance-scorecard",
                customIcon: "clipboard list",
                label: "Performance Scorecard",
                title: "PERFORMANCE SCORECARD",
                subMenus: [],
            },
            {
                pageId: 403,
                name: "ps-data",
                customIcon: "database",
                label: "PS Data",
                title: "PS DATA",
                subMenus: [],
            },
            {
                pageId: 33,
                name: "clinical-constitution",
                icon: "chart bar outline",
                title: "CLINICAL CONSTITUTION",
                subMenus: [],
                role: ['Admin', 'View Only']
            },
            {
                pageId: 56,
                name: "audit",
                customIcon: "calculator",
                label: "REVIEW",
                title: "CLINICAL EXCELLENCE",
                subSubMenus: [
                    { pageId: 561, name: "audit/dashboard", customIcon: "chart bar outline", title: "DASHBOARD" },
                    { pageId: 565, name: "audit/results", customIcon: "file alternate outline", title: "RESULTS" },
                    { pageId: 562, name: "audit/my-audits", customIcon: "user outline", title: "MY REVIEWED CHARTS" },
                    { pageId: 563, name: "audit/to-do-audits", icon: "list ol", title: "TO-DO REVIEWS" },
                    { pageId: 564, name: "audit/all-audits", icon: "table", title: "ALL REVIEWS" },
                    {
                        pageId: 566,
                        name: "audit/setup",
                        icon: "cog",
                        title: "SETUP REVIEWS",
                        role: ['Admin', 'Xray Admin']
                    }
                ]
            },
            { pageId: 57, name: "xray", customIcon: "hospital outline", label: "X-RAY", title: "X-RAY" }
        ]
    },
    { pageId: 1, name: "schedule", icon: "calendar alternate outline", title: "SCHEDULE", subMenus: [] },
    { pageId: 21, name: "timeoff", icon: "clock outline", title: "TIMEOFF REQUEST", subMenus: [] },
    { pageId: 600, name: "provider-expenses", icon: "file invoice dollar", title: "PROVIDER EXPENSES", subMenus: [], role: ['expenses', 'Dentist', 'Hygienists', 'Oral Surgeon', 'Pediatric'] },
    {
        pageId: 2,
        name: "billing",
        icon: "heartbeat",
        title: "CARE",
        subMenus: [],
        role: permissionRoles
    },
    {
        pageId: 24,
        name: "bgoal",
        customIcon: "bgoal",
        title: "bGoal<=>bCARE",
        subMenus: [],
        role: permissionRoles
    },
    {
        pageId: 3,
        name: "caredelta",
        customIcon: "caredelta",
        title: "Care Delta",
        subMenus: [],
        role: ['Admin', 'View Only', 'Regional Manager']
    },
    {
        pageId: 4,
        name: "futurecare",
        icon: "calendar check outline",
        title: "Future Care Review",
        subMenus: [],
        role: ['Admin', 'View Only', 'Regional Manager']
    },
    {
        pageId: 5, name: "payandreports", icon: "dollar", title: "PAY", subMenus: [
            {
                pageId: 33,
                name: "cdp",
                icon: "dollar",
                title: "CDP",
                role: permissionRoles,
                subSubMenus: [
                    {
                        pageId: 35,
                        name: "Cdp Pay",
                        customIcon: "money",
                        title: "PAY",
                        permissions: ['Doctor.Not.altPay', 'User.isAdmin']
                    },
                    { pageId: 36, name: "cdp-reports", customIcon: "chart bar outline", title: "REPORTS" },
                    { pageId: 601, name: "Adjustment Tracker", customIcon: "tasks", title: "Adjustment Tracker" },
                    { pageId: 334, name: "HYN Tracker", customIcon: "chart line", title: "HYN Tracker" },
                    { pageId: 61, name: "writeOff history", customIcon: "history", title: "WriteOff History" },
                    { pageId: 61, name: "adjustment history", customIcon: "history", title: "Adjustment History" },
                    { pageId: 53, name: "pay-validation", customIcon: "calculator", title: "PAY VALIDATION" },
                    { pageId: 49, name: "productionMove", icon: "exchange", title: "PRODUCTION MOVE" },
                    { pageId: 65, name: "treating-doctor", customIcon: "user md", title: "HYG TREATING DOCTOR" }
                ]
            },
            {
                pageId: 34, name: "ortho", customIcon: "tooth", title: "CDP-SMILES", subSubMenus: [
                    { pageId: 37, name: "Ortho Pay", customIcon: "money", title: "Pay" },
                    {
                        pageId: 38,
                        name: "Ortho Reports",
                        customIcon: "chart bar outline",
                        title: "Reports",
                        role: permissionRoles
                    },
                    { pageId: 60, name: "ortho-patient-codes", customIcon: "clipboard list", title: "PATIENT CODES" },
                    { pageId: 59, name: "ortho-pay-validation", customIcon: "calculator", title: "PAY VALIDATION" },
                    { pageId: 61, name: "ortho-change-codes", customIcon: "edit outline", title: "CHANGE CODES" },

                ]
            },
        ]
    },

    {
        pageId: 6,
        name: "usage",
        icon: "pie chart",
        label: "USAGE",
        title: "USAGE",
        subMenus: [],
        role: ['Admin', 'View Only', 'Regional Manager']
    },
    {
        pageId: 7,
        name: "externalsites",
        icon: "desktop",
        label: "EXTERNAL SITES",
        title: "EXTERNAL SITES",
        subMenus: [],
        role: []
    },
    {
        pageId: 10,
        name: "doctor-contracts",
        class: "innerDropdown",
        icon: "certificate",
        title: "Contracts",
        subMenus: [],
        role: []
    },
    {
        pageId: 9,
        name: "my-files",
        class: "innerDropdown",
        icon: "file alternate outline",
        title: "My Files",
        subMenus: [],
        role: []
    },
    {
        pageId: 13,
        name: "reports",
        icon: "chart bar outline",
        title: "REPORTS",
        role: permissionRoles,
        subMenus: [
            {
                pageId: 32,
                name: "powerbi",
                icon: "desktop",
                label: "Power BI Dashboard",
                title: "Power BI Dashboard",
                subMenus: [],
                role: []
            },
            { pageId: 14, name: "care", icon: 'heartbeat', title: "Care" },
            {
                pageId: 27,
                name: "care-delta-report",
                customIcon: "caredelta",
                title: "Care Delta Report",
                role: ['Admin', 'View Only', 'Regional Manager']
            },
            {
                pageId: 28,
                name: "timeoff-request-report",
                icon: "clock outline",
                title: "Time Off Request Summary",
                role: ['Admin', 'View Only', 'Regional Manager']
            },
            {
                pageId: 29,
                name: "offered-work-days",
                icon: "clock outline",
                title: "Offered Work Days",
                role: ['Admin', 'View Only', 'Regional Manager']
            },
            { pageId: 30, name: "bitewing-report-notes", icon: "clock outline", title: "Bitewing Report Notes" },
            { pageId: 15, name: "adjustments", icon: 'adjust', title: "Adjustments" },
            { pageId: 16, name: "writeoffs", icon: 'pencil alternate', title: "Writeoffs" },
            { pageId: 17, name: "soc", icon: 'heartbeat', title: "SOC" },
            {
                pageId: 25,
                name: "bgoal-report",
                customIcon: "bgoal",
                title: "BGoals",
                role: ['Admin', 'View Only', 'Regional Manager']
            },
            {
                pageId: 26,
                name: "budget-goals",
                customIcon: "bgoal",
                title: "Budget Goals ",
                role: ['Admin', 'View Only', 'Regional Manager']
            },

        ]
    },
    {
        pageId: 18,
        name: "practices",
        icon: "building outline",
        label: "PRACTICES",
        title: "PRACTICES",
        subMenus: [],
        role: []
    },
    {
        pageId: 19,
        name: "manage-help",
        icon: "building outline",
        label: "PRACTICES",
        title: "Manage Help",
        subMenus: [],
        role: ['Admin', 'View Only', 'Regional Manager'],
        hide: true
    },
    {
        pageId: 23,
        name: "manage-profile",
        icon: "building outline",
        label: "PRACTICES",
        title: "Manage Profile",
        subMenus: [],
        role: [],
        hide: true
    }
];

export const legendItems = [
    { type: 'button', color: '#d67d38', text: 'Sum Of', description: 'Indicates a Sum Of Contract type' },
    { type: 'button', color: '#1a89a7', text: 'Greater Of', description: 'Indicates a Greater Of Contract type' },
    { type: 'button', color: '#558ce7', text: 'Collections', description: 'Indicates a Collections Contract type' },
    { type: 'button', color: '#21BA45', text: 'GOX Contract', description: 'Indicates a GOX Contract type' },
    { type: 'button', color: '#FF00FF', text: 'GOZ Contract', description: 'Indicates a GOZ Contract type' },
    { type: 'button', color: '#1a89af', text: 'GO/HYN', description: 'Indicates a Greater Of w/HYN Contract type' },
    { type: 'button', color: '#d67d38', text: 'SO/HYN', description: 'Indicates a Sum Of w/HYN Contract type' },
    { type: 'button', color: '#558ce7', text: 'CO/HYN', description: 'Indicates a Collections w/HYN Contract type' },
    { type: 'button', color: '#5FE47F', text: 'GOX/HYN', description: 'Indicates a GOX w/HYN Contract type' },
    {
        type: 'button',
        color: 'cursorPointer',
        text: 'Hygienist / UKG HYN',
        description: 'Indicates a Hygienist Incentive or UKG HYN Contract type'
    },
    {
        type: 'button',
        color: 'grey',
        text: 'Other Contract Types',
        description: 'Indicates other miscellaneous contract types'
    },
    {
        type: 'circle',
        color: 'red',
        text: 'Worked Days',
        description: 'Circular label indicating the number of worked days'
    },
    {
        type: 'label',
        color: '#21BA45',
        text: 'Border Yellow',
        description: 'Yellow border indicates provider is not over base or eligible for bonus',
        pointing: 'left',
        borderClass: 'borderYellow'
    },
    {
        type: 'label',
        color: '#1a89a7',
        text: 'Over Base',
        description: 'Indicates over base with a right arrow',
        pointing: 'right'
    },
    { type: 'label', color: 'green', text: 'Hygienist Incentive', description: 'Indicates Hygienist Incentive pay' },
    { type: 'text', color: 'green', text: 'Owner Practice', description: 'Indicates Owner Practice' },
    { type: 'text', color: 'orange', text: 'Ramp Practice', description: 'Indicates Ramp Practice' },
    {
        type: 'text',
        color: 'black',
        text: 'Base Pay',
        description: 'Indicates provider has different rates for every practice they have worked on'
    },
    { type: 'text', color: 'regularBlack', text: 'Not a Ramp Practice', description: 'Indicates Not a Ramp Practice' },
    {
        type: 'text',
        color: 'regularBlack',
        text: 'Practice Name',
        description: 'Indicates Practice that provider and Hygienist worked together',
        fontStyle: 'italic'
    },
];
export const legendItemsOrtho = [
    { type: 'label', color: '#1a89a7', text: 'Contract', description: 'Indicates contract type' },
    { type: 'text', color: '#28a745', text: 'Practice', description: 'Indicates Practice is approved' },
    { type: 'text', color: '#dc3545', text: 'Practice', description: 'Indicates Practice is disapproved ' },
    { type: 'text', color: '#ffdf00', text: 'Practice', description: 'Indicates Provider has unscheduled treatments' },
    { type: 'text', color: 'black', text: 'Practice', description: 'Indicates Practice is not approved or disapproved ' },
    {
        type: 'text',
        color: 'red',
        text: 'Provider',
        description: 'Indicates provider who have account disables in users table'
    },
];

export const HelpPages = {
    1: { name: "UDR - SCHEDULE" },
    2: { name: "UDR - CARE" },
    3: { name: "UDR - Care Delta" },
    4: { name: "UDR - Future Care Review" },
    6: { name: "UDR - USAGE" },
    7: { name: "UDR - EXTERNALSITES" },
    9: { name: "UDR - DOCS", totalChild: 3 },
    10: { name: "UDR - Dentists View", parent: 9 },
    11: { name: "UDR - Admin List View", parent: 9 },
    12: { name: "UDR - Document List View", parent: 9 },
    13: { name: "UDR - REPORTS", totalChild: 4 },
    14: { name: "UDR - Care", parent: 13 },
    15: { name: "UDR - Adjustments", parent: 13 },
    16: { name: "UDR - Writeoffs", parent: 13 },
    17: { name: "UDR - Standard of Care", parent: 13 },
    18: { name: "UDR - PRACTICES" },
    19: { name: "UDR - OVERVIEW" },
    20: { name: "UDR - MOBILE" },
    21: { name: "UDR - TimeOff Requests" },
    22: { name: "UDR - Doc View By Dentist" },
    23: { name: "UDR - Manage My Profile" },
    24: { name: "UDR - bGOAL < = > bCARE" },
    25: { name: "UDR - bGOAL < = > bCARE REPORT" },
    26: { name: "UDR - BUDGET BGOAL" },
    27: { name: "UDR - CARE DELTA REPORT" },
    28: { name: "UDR - TIME OFF REQUEST SUMMARY" },
    29: { name: "UDR - OFFERED WORK DAYS" },
    30: { name: "UDR - BITEWING REPORT NOTES" },
    31: { name: "UDR - CLINICAL CONSTITUTION" },
    32: { name: "UDR - powerBI" },
    33: { name: "UDR - Cdp", totalChild: 2 },
    34: { name: "UDR - Ortho", totalChild: 2 },
    35: { name: "CDP Pay", parent: 33 },
    36: { name: "CDP Reports", parent: 33 },
    37: { name: "Ortho Pay", parent: 34 },
    38: { name: "Ortho Reports", parent: 34 },
    39: { name: "MY.CDP - Patient Validation" },
    40: { name: "MY.CDP - Adjustment", totalChild: 2 },
    41: { name: "MY.CDP - Adjustment - Setup", parent: 40 },
    42: { name: "MY.CDP - Adjustment Acknowledgement", parent: 40 },
    43: { name: "MY.CDP - Five9 List" },
    44: { name: "MY.CDP - OS PCR" },
    45: { name: "MY.CDP - MDHM" },
    46: { name: "MY.CDP - CSR" },
    47: { name: "MY.CDP - Patient Care Report" },
    48: { name: "MY.CDP - Practice Manager Dashboard" },
    49: { name: "UDR - Production Move", parent: 33 },
    52: { name: "Doctor Contracts" },
    53: { name: "Pay Validation", parent: 33 },
    59: { name: "Ortho Pay Validation", parent: 34 },
    62: { name: "Change Codes", parent: 34 },
}

export const udrPermissions = [
    { text: "All", value: "All", key: "All" },
    { text: "Admin", value: 1, key: "Admin" },
    { text: "Dentist", value: 2, key: "Dentist" },
    { text: "Orthodontics", value: 3, key: "Orthodontics" },
    { text: "Oral Surgeon", value: 4, key: "Oral Surgeon" },
    { text: "Traveling Team", value: 5, key: "Traveling Team" },
    { text: "Credentialing", value: 6, key: "Credentialing" },
    { text: "View Only", value: 7, key: "View Only" },
    { text: "Regional Manager", value: 8, key: "Regional Manager" },
    { text: "Hygienists", value: 9, key: "Hygienists" },
    { text: "Provider Light", value: 10, key: "Provider Light" },
    { text: "SOFD", value: 11, key: "SOFD" },
    { text: "Ortho Manager", value: 15, key: "Ortho Manager" },
    { text: "Pediatric", value: 16, key: "Pediatric" },
    { text: "Practice Manager", value: 17, key: "Practice Manager" },
];

export const brands = [
    { text: 'All', value: 'All', key: 'All' },
    { text: 'SMD', value: 'SMD', key: 'SMD' },
    { text: 'FSD', value: 'FSD', key: 'FSD' },
    { text: 'OTD', value: 'OTD', key: 'OTD' },
    { text: '3CD', value: '3CD', key: '3CD' },
    { text: 'SDD', value: 'SDD', key: 'SDD' }
];

export const toothTypes = [
    { text: 'None', value: 0, key: 'All' },
    { text: 'Letters (Children)', value: 1, key: 'l1' },
    { text: 'Numbers (Adults)', value: 2, key: 'a1' }
];

export const contractNameOptions = [
    { text: 'All', value: null, key: 'All' },
    { text: 'Greater Of', value: 'Greater Of', key: 'Greater Of' },
    { text: 'Sum Of', value: 'Sum Of', key: 'Sum Of' },
    { text: 'Collections', value: 'Collections', key: 'Collections' },
    { text: 'HYG UKG', value: 'UKG HYN', key: 'UKG HYN' },
    { text: 'TMPDOC', value: 'TMPDOC', key: 'TMPDOC' },
    { text: 'TMPHYN', value: 'TMPHYN', key: 'TMPHYN' },
    { text: 'GOX', value: 'GOX', key: 'GOX' },
    { text: 'GOZ', value: 'GOZ', key: 'GOZ' },
    { text: 'Greater Of w/HYN', value: 'Greater Of w/HYN', key: 'Greater Of w/HYN' },
    { text: 'Sum Of w/HYN', value: 'Sum Of w/HYN', key: 'Sum Of w/HYN' },
    { text: 'Collections w/HYN', value: 'Collections w/HYN', key: 'Collections w/HYN' },
    { text: 'GOX w/HYN', value: 'GOX w/HYN', key: 'GOX w/HYN' },
    { text: 'GO GA', value: 'GO GA', key: 'GO GA' },
    { text: 'GO GA w/HYN', value: 'GO GA w/HYN', key: 'GO GA w/HYN' },
    { text: 'Tier', value: 'Tier', key: 'Tier' },
    { text: 'w/HYN', value: 'w/HYN', key: 'w/HYN' }
];

export const isActiveOptions = [
    { text: 'All', value: null, key: 'All' },
    { text: 'Active', value: 'active', key: 1 },
    { text: 'InActive', value: 'inActive', key: 0 }
];

export const isActiveOrthoOptions = [
    { text: 'All', value: null, key: 'All' },
    { text: 'Active', value: true, key: 1 },
    { text: 'InActive', value: false, key: 0 }
];

export const isActiveOptionsOrtho = [
    { text: 'All', value: null, key: 'All' },
    { text: 'Active', value: true, key: 1 },
    { text: 'InActive', value: false, key: 0 }
];

export const rampDateOptions = [
    { text: 'All', value: null, key: 'All' },
    { text: 'Yes', value: true, key: 1 },
    { text: 'No', value: false, key: 0 }
];

export const defaultPage = [
    { value: "schedule", text: "SCHEDULE" },
    { value: "billing", text: "CARE" },
    { value: "bgoal", text: "BGOAL" },
    { value: "futurecare", text: "Future Care Review" },
    { value: "payandreports/cdp-pay", text: "CDP PAY" },
    { value: "payandreports/cdp-reports", text: "CDP REPORTS" },
    { value: "payandreports/adjustment-tracker", text: "ADJUSTMENT TRACKER" },
    { value: "payandreports/saved-cdp-reports", text: "SAVED REPORTS" },
    { value: "payandreports/ortho-pay", text: "ORTHO PAY" },
    { value: "payandreports/ortho-reports", text: "ORTHO REPORTS" },
    { value: "usage", text: "USAGE" },
    { value: "reports/care", text: "REPORTS CARE" },
    { value: "reports/adjustments", text: "REPORTS ADJUSTMENTS" },
    { value: "reports/writeoffs", text: "REPORTS WRITEOFFS" },
    { value: "reports/soc", text: "REPORTS SOC" },
    { value: "reports/bgoal-report", text: "REPORTS BGOAL" },
    { value: "reports/budget-goals", text: "REPORTS BUDGET" },
    { value: "practices", text: "PRACTICES" }
];

export const docTypeOptions = [
    { value: false, text: "All" },
    { value: "other", text: "Other Document" },
    { value: "image", text: "Image" },
    { value: "pdf", text: "PDF" },
    { value: "doc", text: "Contract" }
]

export const acceptFileTypes = {
    image: ".jpg, .jpeg, .png",
    doc: ".doc, .docx",
    pdf: ".pdf",
    other: ".jpg, .jpeg, .png, .pdf"
}

export const acceptHelpFileTypes = ".mp4, .pdf";

export const docsStatusOptions = [
    { value: false, text: "View All" },
    { value: "0", text: "Action Required" },
    { value: "1", text: "Past Request Date" },
    { value: "2", text: "Expired" }
]

export const docsReviewOptions = [
    { value: false, text: "All" },
    { value: "1", text: "Approved" },
    { value: "2", text: "Un-Approved" }
]

export const docSortOptions = [
    { value: "sortByExpireDate", text: "By Expiry Date" },
    { value: "createdAt", text: "By Entry Date" },
    { value: false, text: "None" }
]

export const docRequireOptions = [
    { value: false, text: "All" },
    { value: "required", text: "Required" },
    { value: "services", text: "Services" },
    { value: "misc", text: "Misc" }
]

export const approvalOptions = [
    { value: 0, text: "Pending" },
    { value: 1, text: "Approve" },
    { value: 2, text: "Disapprove" }
]

export const daysType = [
    { value: null, text: "All" },
    { value: true, text: "Match" },
    { value: false, text: "Non-Match" }
]

export const approvalOptionsOrtho = [
    { value: null, text: "All" },
    { value: true, text: "Approved" },
    { value: false, text: "Not Approved" },
]

export const treatmentOptions = [
    { value: null, text: "All" },
    { value: true, text: "Scheduled" },
    { value: false, text: "UnScheduled" },
]

export const payType = [
    { value: null, text: "All" },
    { value: false, text: "Base" },
    { value: true, text: "Over Base" },

]

export const Months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];


export const timeoffStatusOptions = [
    { value: false, text: "View All" },
    { value: "0", text: "New" },
    { value: "3", text: "Pending" },
    { value: "1", text: "Approved" },
    { value: "2", text: "Disapproved" }
]

export const udaRoleOptions = [
    { text: "All", value: null },
    { text: "Dentist", value: "Dentist" },
    { text: "Oral Surgeon", value: "Oral Surgeon" },
    { text: "Hygienists", value: "Hygienists" },
    { text: "Pediatric", value: "Pediatric" },
]

export const customContractFilterOptions = [
    {
        text: "All Scissors", value: 'all', content: (
            <span>All <Icon name='cut' color='grey' /></span>
        )
    },
    {
        text: "Red Scissor", value: 'red_scissor', content: (
            <span><Icon name='cut' color='red' />Red Scissor</span>
        )
    },
    {
        text: "Green Scissor", value: 'green_scissor', content: (
            <span><Icon name='cut' color='green' />Green Scissor</span>
        )
    },
    {
        text: "No Scissor", value: 'no_scissor', content: (
            <span>No <Icon name='cut' color='grey' /></span>
        )
    },
]

export const notesReminderFilterOptions = [
    { text: "All", value: null },
    {
        text: "Red Sign", value: true, content: (
            <Header icon='dollar' color={'red'} />
        )
    },
    {
        text: "Green Sign", value: false, content: (
            <Header icon='dollar' color={'green'} />
        )
    },
]

export const allowDeleteUserId = [163, 1710, 791, 1189]

export const notesType = [
    { text: "Public", value: "Public" },
    { text: "Private", value: "Private" },
    { text: "Financial", value: "Financial" }
]

export const requestTypeOptions = [
    { text: "Requested", value: "requested" },
    { text: "Forced", value: "forced" }
]

export const ageGroupOptions = [
    { text: "Select Group", value: false },
    { text: "0-3 Years", value: "0 and 3" },
    { text: "0-5 Years", value: "0 and 5" },
    { text: "0-10 Years", value: "0 and 10" },
    { text: "0-20 Years", value: "0 and 20" },
    { text: "0-30 Years", value: "0 and 30" },
    { text: "0-40 Years", value: "0 and 40" },
    { text: "0-50 Years", value: "0 and 50" },
    { text: "0-60 Years", value: "0 and 60" },
    { text: "0-70 Years", value: "0 and 70" },
    { text: "0-80 Years", value: "0 and 80" },
    { text: "0-90 Years", value: "0 and 90" },
    { text: "0-100 Years", value: "0 and 100" },
    { text: ">100 Years", value: "0 and 1000" }
]

export const typeOfOptions = [
    { key: "START", text: "Start", value: "S-TART" },
    { key: "SDSTART", text: "SD-Start", value: "SDSTART" },
    { key: "SDCONTRACT", text: "SD-Contract", value: "SDCONTRACT" },
    { key: "DEBOND", text: "Debond", value: "DEBOND" },
    { key: "PH1-START", text: "PH1-Start", value: "PH1-START" },
    { key: "DOT", text: "DOT", value: "DOT" },
    { key: "PATIENT", text: "Patient", value: "PATIENT" },
    { key: "EXAMS", text: "Exams", value: "EXAMS" },
    { key: "CONSULT", text: "Consult", value: "CONSULT" },
    { key: "CONTRACT", text: "Contract", value: "CONTRACT" },
    { key: "RECALL", text: "Recall", value: "RECALL" },
    { key: "N/A", text: "N/A", value: "N/A" },
    { key: "TRADITIONAL", text: "Traditional", value: "Traditional" },
    { key: "CLEAR_HYBRID", text: "Clear Hybrid", value: "Clear Hybrid" },
    { key: "CLEAR", text: "Clear", value: "Clear" },
    { key: "GOLD", text: "Gold", value: "Gold" },
    { key: "GOLD_HYBRID", text: "Gold Hybrid", value: "Gold Hybrid" },
    { key: "PHASE_I", text: "Phase I", value: "Phase I" },
    { key: "RETREAT", text: "Retreat", value: "Retreat" },
    { key: "RETREAT_G", text: "Retreat G", value: "Retreat G" },
    { key: "RETREAT_C", text: "Retreat C", value: "Retreat C" },
    { key: "RETREAT_HG", text: "Retreat HG", value: "Retreat HG" },
    { key: "RETREAT_HC", text: "Retreat HC", value: "Retreat HC" },
    { key: "FULL_CLEAR", text: "Full Clear", value: "Full Clear" },
    { key: "FULL_GOLD", text: "Full Gold", value: "Full Gold" },
    { key: "HYBRID", text: "Hybrid", value: "Hybrid" }
]

export const insuranceTypeOptions = [
    { text: "Select Insurance", value: false },
    { text: "DentaQuest", value: "dentaquest" },
    { text: "Delta Dental", value: "delta dental" },
    { text: "Metlife Dental", value: "Metlife Dental" },
]

export const procedureChangeCodeEffectOptions = [
    { text: "Select", value: false },
    { text: "Add", value: "1" },
    { text: "Remove", value: "-1" },
]
export const yearOptions = [
    { key: "", value: "", text: "All" },
    { key: "2023", value: "2023", text: "2023" },
    { key: "2024", value: "2024", text: "2024" },
    { key: "2025", value: "2025", text: "2025" }
]
export const monthsArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const defaultTimeOffKey = "dda31f75-d0e4-4285-b9eb-cee58eedac2f_Dr.TimeOffRequestGuidelines.pdf"
export const timeOffGuidlines = "https://cdp-uss-uploads.s3.amazonaws.com/dda31f75-d0e4-4285-b9eb-cee58eedac2f_Dr.TimeOffRequestGuidelines.pdf"
export const uploadsBaseLink = "https://cdp-uss-uploads.s3.amazonaws.com/";

export const isActiveRoles = ['Dentist', 'Oral Surgeon', 'Hygienists', 'Doctor', 'Pediatric'];

export const isActive = 'active';

export const AppUserSetup = {
    appName: 'cdp_udr',
    defaultPage: 'default_page'
}

export const deleteCookie = () => {
    const cookie1 = 'cdp-cookie';
    document.cookie = cookie1 + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path='/';"
};

// Bearer header for requests not sent through ApiClient (e.g. ReactS3Uploader signingUrlHeaders)
export const authHeaders = () => ({ Authorization: 'bearer ' + store('authToken') });

export const getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export const setCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const validObj = (obj) => !!obj && (typeof obj === "object") && Object.keys(obj).length > 0;

export const generateUniqueABBR = (abbrKeys) => {
    return abbrKeys.map((item) => {
        return item ? item.split("_")[0] : item;
    }).filter((e, i, self) => i === self.indexOf(e));
}


export const UDRDownList = {
    bCARE: "bCare",
    SMILESSAGE: "SMILES - Sage",
    SMILESUKG: "SMILES - UKG",
    CDPPay: "CDP - PAY",
    SMILESPay: "SMILES - PAY",
};

/* Role ids:
 2 : Dentist
 3 : Orthodontics
 4 : Oral Surgeon
 9 : Hygienists
 16 : Pediatric
 */
export const dentistTypes = [2, 4, 9, 16]
export const dentistTypesOrtho = [2, 3, 4, 9, 10, 16]

export const DentistHygienistsPediatricType = [2, 9, 16]
export const DentistOrthodonticsPediatricType = [2, 3, 16]
export const HygienistsPediatricType = [9, 16]

export const instructionLink = "https://scribehow.com/shared/How_to_find_Pay_Stubs__A9WxpwWvQIGkoPWGHVPwyg"
export const adpLink = "https://online.adp.com/signin/v1/?APPID=WFNPortal&productId=80e309c3-7085-bae1-e053-3505430b5495&returnURL=https://workforcenow.adp.com/&callingAppId=WFN&TARGET=-SM-https://workforcenow.adp.com/theme/index.html%23/Myself/Profile"
